export default "__VITE_ASSET__e836f9b7__"